"use client";

import { CtaButton } from "@/component/cta-button";
import { routes } from "@/config/routes";
import { useLanguage } from "@/context/language-context";
import { useTranslations } from "@/hooks/use-translations";
import { IconArrowRight } from "@tabler/icons-react";
import Link from "next/link";

export default function Cta() {
    const t = useTranslations();
    const { language } = useLanguage();

    // Don't render until translations are loaded to prevent layout shift
    if (!t) {
        return <div className="flex justify-center min-h-[80px] items-center" />;
    }

    return (
        <div className="flex justify-center min-h-[80px] items-center">
            <CtaButton
                as={Link}
                href={routes.preRegistration(language)}
                className="plausible-event-name=cta"
                endContent={<IconArrowRight size={20} />}
            >
                {t.hero.cta}
            </CtaButton>
        </div>
    );
}